module.exports = __webpack_public_path__ + "img/category_40.d70f6648.png";